/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Openpositions_Label1Inputs */

const en_company_registration_openpositions_label1 = /** @type {(inputs: Company_Registration_Openpositions_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open / Positions to Fill`)
};

const de_company_registration_openpositions_label1 = /** @type {(inputs: Company_Registration_Openpositions_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`offene / zu besetzende Stellen`)
};

/**
* | output |
* | --- |
* | "Open / Positions to Fill" |
*
* @param {Company_Registration_Openpositions_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_registration_openpositions_label1 = /** @type {((inputs?: Company_Registration_Openpositions_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Openpositions_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_openpositions_label1(inputs)
	return en_company_registration_openpositions_label1(inputs)
});
export { company_registration_openpositions_label1 as "company_registration_openPositions_label" }